import {
  DrawerProps,
  IconButton,
  Stack,
  TabPanel,
  TabPanelProps,
  Td,
  Th,
  Tr,
} from '@chakra-ui/react';
import { useFetchUomsQuery } from 'api';
import { UnitOfMeasureResponse } from 'api/bindings/UnitOfMeasureResponse';
import { usePagination } from 'core';
import { AppTable } from 'features/table';
import { useState } from 'react';
import { FiPenTool, FiPlus } from 'react-icons/fi';
import { CreateUnitOfMeasurementDrawer } from './CreateUnitOfMeasurementDrawer';
import { EditUnitOfMeasurementDrawer } from './EditUnitOfMeasurementDrawer';
import { AppButton } from 'features/components';

export interface UnitOfMeasurementsTabPanelProps
  extends Omit<TabPanelProps, 'onSubmit'> {}

export const UnitOfMeasurementsTabPanel = (
  props: UnitOfMeasurementsTabPanelProps
) => {
  const { ...rest } = props;

  // State
  const [createUom, setCreateUom] = useState<boolean>();
  const [editingUom, setEditingUom] = useState<UnitOfMeasureResponse>();
  const [pagination, setPagination] = usePagination();

  // Fetches
  const { data: uoms, isLoading } = useFetchUomsQuery({
    ...pagination,
  });

  let body = (
    <>
      <Tr>
        <Td>Loading...</Td>
      </Tr>
    </>
  );

  if (!isLoading) {
    body = (
      <>
        {uoms?.items.map((uom, i) => (
          <Tr key={i}>
            <Td>
              <IconButton
                icon={<FiPenTool />}
                aria-label="Edit unit of measurement"
                onClick={() => setEditingUom(uom)}
              />
            </Td>
            <Td>{uom.name}</Td>
            <Td>{uom.abbreviation}</Td>
          </Tr>
        ))}
      </>
    );
  }
  return (
    <TabPanel {...rest}>
      {createUom && (
        <CreateUnitOfMeasurementDrawer
          onClose={() => setCreateUom(undefined)}
        />
      )}
      {editingUom && (
        <EditUnitOfMeasurementDrawer
          uom={editingUom}
          onClose={() => setEditingUom(undefined)}
        />
      )}
      <Stack spacing={4}>
        <AppTable
          title="Units of Measurement"
          pagination={{
            ...pagination,
            itemCount: Number(uoms?.itemCount ?? 0),
            pageCount: Number(uoms?.pageCount ?? 0),
          }}
          onPaginationChange={setPagination}
          body={body}
          buttonGroup={(props) => (
            <AppButton
              leftIcon={<FiPlus />}
              variant={'solid'}
              onClick={() => setCreateUom(true)}
            >
              Create Unit of Measure
            </AppButton>
          )}
          header={
            <>
              <Tr>
                <Th></Th>
                <Th>Name</Th>
                <Th>Abbreviation</Th>
              </Tr>
            </>
          }
        />
      </Stack>
    </TabPanel>
  );
};
